<template>
  <div class="header h-padding">
    <div>
      <router-link to="/">
        <img class="img" src="../../assets/images/logo/consultied_logo_new.svg" height="30px" alt />
        <span class="white--text logo">Meritios</span>
      </router-link>
    </div>

    <div
      style="display: flex;flex-direction: row;align-self: flex-end;position: relative"
      class="white--text __bar"
    >
      <span class="names">{{getMeProfile.user.first_name +" "+ getMeProfile.user.last_name | validate }}</span>
      <v-avatar size="30" class="mr-1" @click="hideMenu=!hideMenu">
        <img
          ref="user-pic"
          :src="$fullUrl('images/profiles/'+getMeProfile.user.profile_picture)"
          v-if="getMeProfile.user.profile_picture"
          style="cursor:pointer;"
        />
      </v-avatar>
      <span style="cursor:pointer;">
        <img
          ref="bt-toggle-dropdown"
          src="../../assets/setting_icon.svg"
          @click="hideMenu=!hideMenu"
        />
      </span>
      <span class="ml-1" style="cursor:pointer;">
        <img src="../../assets/arrow_down.svg" @click="hideMenu=!hideMenu" />
      </span>
      <div
        class="__dropdown-results"
        v-show="hideMenu"
        v-closable="{exclude: ['bt-toggle-dropdown','user-pic'],handler: 'hideDropDownMenu'}"
      >
        <div class="__dropdown-item">
          <router-link to="/profile/consultant">
            <span>Profile</span>
          </router-link>
        </div>
        <div class="__dropdown-item">
          <a href>
            <span>Settings</span>
          </a>
        </div>
        <div class="__dropdown-item">
          <a href @click="logOut">
            <span>Log out</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router.js";

export default {
  name: "tool-bar",
  sockets: {
    connect: function () {},
    notification: function (payload) {
      if (payload.id === this.userId) {
        this.notifications = this.notifications + 1;
      }
    },
    message: function (payload) {
      if (payload.id === this.userId) {
        this.messages = this.messages + 1;
        console.log(this.messages);
      }
    },
    network: function (payload) {
      if (payload.id === this.userId) {
        this.networks = this.networks + 1;
      }
    },
    logOut() {
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
      this.$router.push({ name: "login" });
    },
  },
  data() {
    return {
      isEditing: false,
      toggleSearch: true,
      showNotification: false,
      model: null,
      hideSearch: true,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      search: null,
      menus: [
        { title: "Profile", path: "user-profile" },
        //TODO:make a logout url
        { title: "Logout", path: "user-profile" },
      ],
      overflows: [
        { title: "Home", path: "/feeds" },
        { title: "Network", path: "/network" },
        { title: "Messages", path: "/messages" },
        { title: "Notification", path: "/notifications" },
      ],
      hideMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      "getMeProfile",
      "getHelper",
      "getConsultants",
      "getDrawer",
      "getTags",
    ]),
    userId() {
      return this.getMeProfile.id;
    },
    fields() {
      //   console.log(this.model)
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key],
        };
      });
    },
    items() {
      return this.entries.map((entry) => {
        const Description =
          entry.Description.length > this.descriptionLimit
            ? entry.Description.slice(0, this.descriptionLimit) + "..."
            : entry.Description;

        return Object.assign({}, entry, { Description });
      });
    },
  },
  methods: {
    hideDropDownMenu() {
      this.hideMenu = false;
    },
    checkLogout(route) {
      if (route == "Logout") {
        return true;
      }
    },
    moveto() {
      this.$router.push({ name: "people_search" });
    },
    newRoute(path) {
      router.push(path);
    },
    gotoProfile(id) {
      this.hideSearch = true;
      this.$router.push({ name: "profile-view", params: { id: id } });
    },
    gotoTag(tag) {
      this.hideSearch = true;
      this.$router.push({ name: "feeds", params: { tag: tag } });
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_ME_PROFILE_DATA");
    },
    logOut() {
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
    },
    manageDialogSearch(dial) {
      this.$store.dispatch("DIALOG_SEARCH", dial);
    },
    showDialogSearch() {
      this.manageDialogSearch(!this.getDialogSearch);
    },
    outside: function (e) {
      this.manageDialogSearch(false);
    },
    accept(notification) {
      this.$store.dispatch("GRANT_PERMISSION", { member: notification });
    },
    decline() {},
  },

  watch: {
    search: function (val) {
      this.hideSearch = false;
      if (val !== "") {
        if (!val.startsWith("#")) {
          this.toggleSearch = true;
          this.$store.dispatch("POST_SEARCH_CONSULTANTS", { query: val });
        } else {
          this.toggleSearch = false;
          this.$store.dispatch("POST_SEARCH_TAGS", { query: val.substring(1) });
        }
      }
    },
  },
  mounted() {
    console.log("why this ");
    //vm.$socket.emit("register", this.getMeProfile.id);
    this.$store.dispatch("GET_ME_PROFILE_DATA");
  },
  created() {},
};
</script>

<style lang="scss" scoped>
a {
  color: #fff;
  text-decoration: none;
  &:hover {
    text-decoration: none;
    color: #fff;
  }
}
.header {
  z-index: 1;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
  background: linear-gradient(to right, #1ba5a4, #1885ad);
  padding: 0.4rem 0.4rem 0.4rem 0.5rem;
  .logo {
    font-size: 11px;
    position: relative;
    top: 7px;
    @media (min-width: 100px) and (max-width: 930px) {
      display: none;
    }
  }
  .img {
    width: 25px;
    height: 25px;
  }

  .search {
    position: relative;
    margin-left: -30%;
    font-size: 14px;
    width: 10%;
    color: #808080;
    font-weight: lighter;
    @media (min-width: 300px) and (max-width: 650px) {
      margin-left: 0;
      width: 60%;
    }
    .__btn {
      position: absolute;
      left: 273%;
      top: 0;
      cursor: pointer;
      background-image: url("../../assets/icons/search__white.svg");
      background-repeat: no-repeat;
      background-size: 15px 15px;
      height: 25px;
      width: 30px;
      background-position: center;
      border-radius: 7px;
      background-color: #1ba5a4;
    }
    input {
      width: 300%;
      border-radius: 0 !important;
      @media (min-width: 300px) and (max-width: 650px) {
        width: 100%;
      }
      padding: 0 10px;
      height: 25px;
      border: none !important;
      /*box-shadow: 0 4px 3px rgba(0,0,0,0.16);*/
      /*-webkit-box-shadow: 0 4px 3px rgba(0,0,0,0.16);*/
      /*-moz-box-shadow: 0 4px 3px rgba(0,0,0,0.16);*/
      outline: none;
      background-color: #ffffff;
    }
    .__results {
      position: absolute;
      left: 0;
      top: 35px;
      width: 450%;
      @media (min-width: 300px) and (max-width: 650px) {
        width: 100%;
      }
      box-shadow: 0 4px 3px rgba(0, 0, 0, 0.16);
      z-index: 999;
      padding: 10px;
      background: #fff;
      .__item {
        display: flex;
        cursor: pointer;
        border-bottom: 0.4px solid rgba(102, 102, 102, 0.4);
        padding-bottom: 10px;
        img {
          width: 40px;
          height: 40px;
          margin-top: 2px;
          padding: 3px;
          border-radius: 100px;
          border: 1px solid #808080;
          @media (min-width: 300px) and (max-width: 650px) {
            width: 20px;
            height: 20px;
          }
        }
        .__col {
          display: flex;
          margin-left: 5%;
          flex-direction: column;
          .__username {
            font-weight: normal;
            font-size: 14px;
            @media (min-width: 300px) and (max-width: 650px) {
              font-size: 12px;
            }
          }
          .__names {
            font-weight: lighter;
            @media (min-width: 300px) and (max-width: 650px) {
              font-size: 8px;
            }
          }
        }
        .hash {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #cccccc;
          span {
          }
        }
      }
    }
  }
}
.h-padding {
  padding-left: 15% !important;
  padding-right: 15% !important;
  @media (min-width: 300px) and (max-width: 750px) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .__bar {
    box-sizing: border-box;
    .__menu-item {
      box-sizing: border-box;
      @media (min-width: 300px) and (max-width: 650px) {
        display: none;
      }
    }
    a {
      margin-top: 3px;
      box-sizing: border-box;
      span {
        margin-right: 10px;
        font-size: 12px;
        margin-top: 5px;
        box-sizing: border-box;
        padding: 3px 10px 3px 2px !important;
        &:hover {
          font-weight: bold;
        }
      }
      .__active {
        font-weight: bold;
      }
    }
    .__dropdown-results {
      position: absolute;
      right: 0;
      top: 30px;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.16);
      z-index: 999;
      padding-bottom: 10px;
      background: #fff;
      .__dropdown-item {
        padding-top: 10px;
        a {
          padding: 7px 10px;
          span {
            color: #1885ad;
            &:hover {
              color: #1ba5a4;
            }
          }
        }
      }
    }
  }
}
.__colored {
  color: #1ba5a4;
}
.__btns {
  display: flex;
  width: 40%;
  margin-left: 50px;
  margin-top: 10px;
  justify-content: space-between;
  .cancel {
    color: #1ba5a4;
    cursor: pointer;
    font-weight: lighter;
    height: 15px;
    padding: 0px 10px;
    font-size: 12px;
  }
  .save {
    background: #1ba5a4;
    color: #fff;
    font-size: 12px;
    font-weight: lighter;
    cursor: pointer;
    border-radius: 5px;
    height: 15px;
    padding: 0px 10px;
  }
}
.badge {
  position: absolute;
  background: #ff1d1d;
  min-width: 15px;
  border-radius: 100%;
  margin: 0 !important;
  color: #fff;
  min-height: 16px;
  padding-top: 4px;
  text-align: center;
  top: -10px;
  right: 0;
  font-size: 9px;
  &:hover {
    color: #fff !important;
  }
}
.names {
  font-size: 11px;
  margin-right: 10px;
  margin-top: 5px;
}
</style>